import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import { Col } from "reactstrap";

import CGridstack from 'components/CGridstack';


export default function GridStackFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled, accessList } = props;

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register } = formManager;

    const [gridData, setGridData] = React.useState();
    const [itemVersioning, setItemVersioning] = React.useState("");
    const [cptModels, setCptModels] = React.useState(null);
    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        var srcArgs = data.argumentsObj?.loadObj;
        //var tagLabel = data.argumentsObj?.cfgTag;
        var args = {};
        if (srcArgs && Object.keys(srcArgs).length && srcArgs.url) {
            Object.keys(srcArgs).forEach((key) => {
                var valueArgs = srcArgs[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (accessList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + srcArgs.url;
            commonFunc.getMethod(url, args).then((responseData) => {
                var dataRes = responseData.data;
                if (dataRes.isSuccess) {
                    //console.debug(dataRes.result);


                    var models = dataRes.result;//dataModels.result.models

                    loadGridStack(models);
                } else {
                    /*Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });*/
                }
            });
        }
        else {
            var modelsSrc = modelFctManager.getModelsList();
            if (modelsSrc) {
                loadGridStack(modelsSrc);
            }
        }


        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    register(bindPropResult);

    //var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));

    var btnClass = "m-1";
    var btnSupClass = "";
    var btnStyle = { };
    var altStyle = {};
    var frameClass = "";
    var frameStyle = {};
    var titleWidthClass = "";
    var titleWidthStyle = {};
    var iconsStyle = { color: "#888888", fontSize: "20px" };
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }
    if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length <= 1)) btnSupClass += " btn-icon ";


    function loadGridStack(models) {
        var curUser = modelFctManager.getUser();
        var targetRoles = curUser?.roles ? curUser.roles[0] : null;

        var tagLabel = data.argumentsObj?.cfgTag;

        var siteModels = {};
        var localGridData;
        var srcModel;

        var itemVersionning = "";
        var resFilter;
        if (models.length) {
            resFilter = models?.filter((model) => {
                if (model.extID === tagLabel) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }
    
                siteModels[model.extID] = JSON.parse(model.value);
    
                return model.extID === tagLabel + "_" + targetRoles;
            });
            if (resFilter && resFilter.length) {
                localGridData = resFilter[0].value;
            }
            else if (srcModel) {
                localGridData = srcModel.value;
            }
            if (localGridData && localGridData.length) {
                var temp = JSON.parse(localGridData);
                if (temp?.length) itemVersionning = (!commonFunc.isBlank(temp[0].versionGrid) ? ("_" + temp[0].versionGrid) : "");
            }
        }
        else {
            siteModels = models;
            var cfgModel = models[tagLabel];
            var cfgRoleModel = models[tagLabel + "_" + targetRoles];

            srcModel = cfgModel;//TODO/TEMP : voir pour les modèles par site
            /*if (cfgModel) {
                if (cfgModel.siteID > 0 || (cfgModel.siteID === -1)) {
                    srcModel = cfgModel;
                }
            }*/

            resFilter = cfgRoleModel ? [cfgRoleModel] : [];

            if (resFilter?.length) {
                localGridData = resFilter[0];
            }
            else if (srcModel) {
                localGridData = srcModel;
            }
            if (localGridData?.length) {
                itemVersionning = (!commonFunc.isBlank(localGridData[0].versionGrid) ? ("_" + localGridData[0].versionGrid) : "");
                localGridData = JSON.stringify(localGridData);
            }
        }

        setGridData(localGridData);
        setItemVersioning(itemVersionning);
        setCptModels(siteModels);
    }


    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_gridStack");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            btnClass += supBoxSize;
        }

        if (design.height) btnStyle.height = design.height;
        if (design.width) btnStyle.width = design.width;

        if (design.margin) {
            btnStyle.margin = design.margin;
            btnClass = btnClass.replace("m-1", "");
        }
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                btnStyle.marginTop = design.marginTop;
            }
            else {
                btnSupClass += design.marginTop;
            }
        }

        //if (design.fontColor) btnStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        //if (designIcon.fontSize) btnStyle.fontSize = design.fontSize;
        Object.assign(btnStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(altStyle, modelFctManager.setCustomBackground(design, data));
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_gridStackTitle", true);
    if (designTitle) {
        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var split = designTitle.alignment.split("|");
            split.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
    }
    var designIcon = data.customDesign?.designIcon;
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_gridStackIcon", true);
    if (designIcon) {
        if (designIcon.fontColor) iconsStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconsStyle.fontSize = designIcon.fontSize;
    }



    //Affichage des boutons paramètrages gridstack
    var hideButtons = false;
    if (modelFctManager.dataCfg?.gridButtons) {
        var user = modelFctManager.getUser ? modelFctManager.getUser() : null;
        if (modelFctManager.dataCfg.gridButtons[data.subType]?.startsWith) {
            if (modelFctManager.dataCfg.gridButtons[data.subType].startsWith("roles:")) {
                hideButtons = true;
                var targetRoles = user?.roles ? user?.roles : null;
                var requiredRoles = modelFctManager.dataCfg.gridButtons[data.subType].replace("roles:", "");
                var splitR = requiredRoles.split(";");
                targetRoles?.forEach((role) => {
                    hideButtons &= !(splitR.indexOf(role) >= 0);
                });
            }
            else if (modelFctManager.dataCfg.gridButtons[data.subType].startsWith("excludedRoles:")) {
                var targetERoles = user?.roles ? user?.roles : null;
                var excludedRoles = modelFctManager.dataCfg.gridButtons[data.subType].replace("excludedRoles:", "");
                var splitExcludedR = excludedRoles.split(";");
                targetERoles?.forEach((role) => {
                    if (splitExcludedR.indexOf(role) >= 0) hideButtons = true;
                });
            }
        }
        else if (modelFctManager.dataCfg.gridButtons[data.subType] === false) {
            hideButtons = true;
        }
    }

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => { return modelFctManager.componentTyped(child, { ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false), stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup")) }); }) || "";

    //console.debug(cptModels);
    var curUser = modelFctManager.getUser();
    var baseForm = gridData ? <div>    
        <CGridstack key={data.subType} target={"gs-" + data.subType} type={"options" + data.subType + (curUser?.groupSId || "") + itemVersioning} dbClientID={((curUser?.clientID + "_") || "")} data={gridData} configModel={cptModels} gridClass={""} unusedclass={`${btnClass} ${btnSupClass}`} actionsClass={"text-secondary"} hideButtons={hideButtons}
            parentProps={{ type: "wgt", dataCfg: modelFctManager.dataCfg }} getUser={modelFctManager.getUser} appProps={modelFctManager.appProps} checkRights={modelFctManager.checkRights} getRoutes={modelFctManager.getRoutes} parentGenArgs={{ currentCache: modelFctManager.rootCache, toolbarArgs: modelFctManager.toolbarArgs }}>
            {childs}
        </CGridstack>
    </div> : "";
    return <Col data-name="GridStackFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}